export const role = {
  newRole: "New Role",
  roleDeletion: "Role Deletion",
  roleDetails: "Role Details",
  // Format: type ["detail1", "detail2", ......]
  deleteInformation: `To delete the role "{0}" you must apply a new role or delete a user from the list below.`,
  selectRole: "Select a role",
  deleteUser: "Delete Account",
  download: "Download",
  workXConnectCloud: "CWorkX Connect Cloud",
  // Format: type ["detail1", "detail2", ......]
  deleteNoUsedTip:
    'The role "{0}" will be deleted. Are you sure you want to proceed?',
  // Format: type ["detail1", "detail2", ......]
  deleteUsedTip:
    "Confirm to delete the role {0} and apply the changes? | Confirm to delete the roles {0} and apply the changes? ",
  pleaseInputRoleName: "Please input a role name",
  roleNameAlreadyExist: "The role name '{0}' already exists",
  failedToSaveRoleNameAlreadyExist:
    "Failed to save. The role name already exists.",
  changeBilling: "Change Payment",
  uploadVideos: "Upload Videos",
  viewUploadVideos: "View Uploaded Videos",
  downloadVideos: "Download Videos",
  deleteVideos: "Delete Videos",
  workxConnection: "CWorkX Connect APP - sign in as user role",
  uploadDriversFaceIDPhoto: "Upload Driver's Face ID Photo",
  driversEditPermissionMustBeEnabled: "Drivers edit permission must be enabled",
  vehicleCalibrationRegistrationAndSettings: "System Registration",
  vehiclesEditPermissionMustBeEnabled:
    "Vehicles edit permission must be enabled",
  historyMustBeEnabled: "History must be enabled",
  enabled: "Enabled",
  disabled: "Disabled",
  video: "Video",
  workxConnectionApplet: "CWorkX WeChat Applet",
  vehicleRepair: "Vehicle Repair",
  vehicleMaintenance: "Vehicle Maintenance",
  editRole: "Edit Role",
  historyAlert: "Alert / History",
};
